import { useMutation, useQuery } from "convex/react";
import { usePaginatedQuery } from "convex/react";

import { api } from "@convex/_generated/api";

export function useEmails() {
  const { results: emails, status, loadMore } = usePaginatedQuery(
    api.emails.listByUser,
    {},
    { initialNumItems: 20 },
  );
  const unreadCount = useQuery(api.emails.countUnread) ?? 0;
  const markAsRead = useMutation(api.emails.markAsRead);

  return { emails, loadMore, markAsRead, status, unreadCount };
}
